import classNames from 'classnames';
import React, { useContext } from 'react';

import { RicosContext } from './../../../../../ricos-context';
import { GalleryOptions_Thumbnails_Alignment } from './../../../../../ricos-schema/next-schema';
import type { LogBiFn } from './../../../../../_shared/bi-context-provider/bi-context-provider';
import { ThumbnailPicker, usePanelContainerElement } from './../../../../../ui-components';

import {
  LAYOUT_SETTINGS_THUMBNAIL_PLACEMENT_THUMBNAIL,
  LAYOUT_SETTINGS_THUMBNAIL_PLACEMENT_THUMBNAIL_PICKER,
} from '../../../../data-hooks';
import { LayoutThumbnailsIcon } from '../../../../icons';
import classes from './thumbnail-alignment-control.rtlignore-scss';

type Props = {
  value: GalleryOptions_Thumbnails_Alignment;
  onChange: (value: GalleryOptions_Thumbnails_Alignment) => void;
  logBi: LogBiFn;
};

export const ThumbnailAlignmentControl: React.FC<Props> = ({ value, onChange, logBi }) => {
  const { t } = useContext(RicosContext);
  const containerEl = usePanelContainerElement();

  return (
    <ThumbnailPicker
      title={t('GallerySettings_Thumbnail_Placement')}
      selectedValue={value}
      onChange={onChange as (v: string | number) => void}
      dataHook={LAYOUT_SETTINGS_THUMBNAIL_PLACEMENT_THUMBNAIL_PICKER}
      dataSource={dataSource.map(({ value }) => ({
        value,
        dataHook: LAYOUT_SETTINGS_THUMBNAIL_PLACEMENT_THUMBNAIL + value,
        renderBackgroundImage: props => (
          <LayoutThumbnailsIcon
            className={classNames(
              classes.thumbnailPlacementSelector,
              classes[`thumbnailPlacementSelector_${value}`]
            )}
            {...props}
          />
        ),
      }))}
      tooltipAppendTo={containerEl}
      logBi={logBi}
    />
  );
};

const dataSource: { value: GalleryOptions_Thumbnails_Alignment }[] = [
  {
    value: GalleryOptions_Thumbnails_Alignment.BOTTOM,
  },
  {
    value: GalleryOptions_Thumbnails_Alignment.LEFT,
  },
  {
    value: GalleryOptions_Thumbnails_Alignment.TOP,
  },
  {
    value: GalleryOptions_Thumbnails_Alignment.RIGHT,
  },
];
